import { Grid2 } from '@mui/material';
import FormInputSelect from '@components/forms/FormInputSelect';
import FormInputDate from '@components/forms/FormInputDate';
import { subYears } from 'date-fns';
import { ALL_GENDER_OPTIONS, ALL_GRADE_OPTIONS } from '@type/db-types';
import { ACTIVE_SINCE_OPTIONS } from './AddWrestlerUtils';

// const COED_OPTIONS = [
//     { value: 'co-ed', label: 'CO-ED' },
//     { value: 'girls-only', label: 'Girls Only' },
// ];

export default function WrestlerBirthGenderForm() {
    return (
        <>
            <Grid2 size={{ sm: 12, md: 6 }} alignSelf={'center'}>
                <FormInputDate
                    datePickerProps={{ maxDate: subYears(new Date(), 4) }}
                    label="Birthday"
                    name="birthday"
                />
            </Grid2>
            <Grid2 size={{ sm: 12, md: 6 }}>
                <FormInputSelect label="Gender" name="gender" options={ALL_GENDER_OPTIONS} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
                <FormInputSelect name="grade" label="Grade" options={ALL_GRADE_OPTIONS} />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
                <FormInputSelect
                    label="Wrestling Since (experience)"
                    name="activeSince"
                    options={ACTIVE_SINCE_OPTIONS}
                />
            </Grid2>

            {/* For girls, allow them to prefer wrestling only girls */}
            {/* {gender === 'female' ? (
                    <FormInputSelect
                                                label="Prefer to wrestle CO-ED?"
                        name="girlsOnly"
                        options={COED_OPTIONS}
                    />
                ) : null} */}
        </>
    );
}
